import { QUERY_KEYS } from 'api/query-keys';
import { sharedProjectService } from 'api/services';
import { ProjectDetail } from 'api/services/project/project-service.schema';
import { useQuery, UseQueryResult } from 'react-query';
import { useSiteDetection } from 'shared/hooks';

export function useGetProjectDetail(projectId: string): UseQueryResult<ProjectDetail> {
  const siteDetection = useSiteDetection();

  return useQuery(
    QUERY_KEYS.projectDetail(projectId),
    async () => await sharedProjectService.getProjectDetail(siteDetection.site, projectId)
  );
}
